import Konva from 'konva';
import { KonvaStage, VIEW } from '../../roadMapComponent/konvaStage';
import GraphicFactory from './graphic';

class Stage extends KonvaStage {
  constructor(payload) {
    super(payload);
    this.payload = payload;

    const { container } = this.payload;
    const { clientWidth, clientHeight } = container;

    this.stage = new Konva.Stage({
      container,
      width: clientWidth,
      height: clientHeight,
      draggable: true,
    });

    this.stage.on('click', (e) => {
      if (!e.target.id()) {
        this.randertmpLayer();
        this.payload.listeners.stageClick(e);
      }
    });

    this.svgLayer = new Konva.Layer();
    this.pointLayer = new Konva.Layer();
    this.tmpLayer = new Konva.Layer();

    this.stage.add(this.svgLayer);
    this.stage.add(this.tmpLayer);
    this.stage.add(this.pointLayer);

    this.pointLayer.draw();
    this.svgLayer.draw();
    this.tmpLayer.draw();

    // 缩放和位移相关
    this.graphicPosition = { x: 0, y: 0 };
    this.graphicScale = 1;
    this.graphicDelay = 500;
    this.dragTimer = 0;

    let imgWidth = 4000;
    let imgHeight = 4000;
    if (this.payload.svgAlignParam) {
      imgWidth = this.payload.svgAlignParam.img_width;
      imgHeight = this.payload.svgAlignParam.img_height;
    }
    // scale 大小
    const scale = Math.min(clientWidth / imgWidth, clientHeight / imgHeight);
    this.stage.scale({ x: scale, y: scale });
    let x = 0;
    x = (clientWidth - imgWidth * scale) / 2;
    this.stage.x(x);

    // 鼠标点，跟随鼠标移动
    this.mousePoint = new Konva.Circle({
      id: -1,
      radius: 5,
      fill: 'blue',
    });
    this.pointLayer.add(this.mousePoint);

    // 当前的点
    this.prevPoint = null;
    this.prevLine = null;
    this.curPoints = null;
    this.curShape = null;
    this.snapLine = null;
    // 坐标点集合
    this.pointDict = {};
    // 图形集合
    this.graphicList = [];
    this.svgShapes = [];

    this.pois = [];
    // 拖拽的节点
    this.draggingLines = [];

    this.rightClickCount = 0;
    this.viewType = 1;

    this.events = {
      keyboardHandler: (e) => {
        this.keyboardHandler(e);
      },
    };

    this.initSvg();
    this.initEvents();
  }

  addGraphic(type, data = [], property = {}, group_id, group_type, id = null) {
    const graphic = GraphicFactory.buildGraphic({
      id,
      type,
      data,
      group_id,
      group_type,
      property,
    }, this);

    if (!graphic.ele) return null;

    if (this.view === VIEW.SELECTION) {
      if (graphic.canDraggable && graphic.ele) {
        graphic.ele.draggable(true);
      }
    }
    this.graphicList.push(graphic);

    if (this.payload.listeners.graphicChanged) {
      this.payload.listeners.graphicChanged(graphic.toObject());
    }

    return graphic;
  }

  randertmpLayer() {
    this.tmpLayer.destroyChildren();
    this.tmpLayer.batchDraw();
  }

  keyboardHandler() {}

  pointClickHandler(e) {
    if (e.evt.button === 0 && this.view === VIEW.SELECTION) {
      this.render();
      if (this.userState) return;
      this.payload.listeners.pointClick(
        this.graphicList.find(i => i.id === e.currentTarget.id()).toObject(),
        'graphic',
        this.pointDict[e.currentTarget.id()],
      );
      if (this.viewType !== 1) {
        this.userState = true;
      }
    }
  }

  updateUserPoint(id) {
    const el = this.graphicList.find(i => i.property.pano_id === id);
    if (!el) return;
    el.select();
  }

  updateUserState(state) {
    this.userState = state;
  }

  updatePanState(id, state) {
    const el = this.graphicList.find(i => i.property.pano_id === id);
    el.property.state = state;
    el.updateState();
    this.pointLayer.batchDraw();
  }

  setViewType(type) {
    this.viewType = type;
  }
}

export {
  Stage,
  VIEW,
};
